/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientDiagnosisTeeth = sqliteTable('patient_diagnosis_teeth', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  diagnosis_entry_id: text('diagnosis_entry_id'),
  patient_id: text('patient_id'),
  encounter_id: text('encounter_id'),
  tooth: text('tooth'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
